<template>
    <v-container fluid class="white elevation-4 pt-0 pb-0">
        <main-app-bar :title="title">
            <template v-slot:buttons>
                <button class="btn-back" @click="goBack">
                    <v-icon>$arrowLeft</v-icon>
                </button>
                <v-btn v-if="holidayTypes.length"  @click="showPopup = true">Create</v-btn>
            </template>
        </main-app-bar>
        <v-row class="d-block grey lighten-4">
            <div class="pa-3">
                <v-btn-toggle
                    v-model="toggleName"
                    color="primary"
                    tile
                    group
                    mandatory
                >
                    <v-btn class="ma-0 mr-3 px-5 py-4" :value="0" :ripple="false" @click="resetFilters">
                        leaves
                    </v-btn>
                    <v-btn v-if="routeName === 'allEmployeeHoliday'" class="ma-0 mr-3 px-5 py-4" :value="1" :ripple="false" @click="resetFilters">
                        lates
                    </v-btn>
                </v-btn-toggle>
            </div>
            <v-toolbar  flat class="pa-0 transparent" height="auto">
                <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center py-0">
                        <v-btn color="black lighten-2" text class="btn-filter pa-1" @click="filterOpened = !filterOpened">
                            Filters
                            <v-icon right>$filter</v-icon>
                        </v-btn>
                        <div class="ml-5 d-inline-block">
                            <v-chip v-for="chip in filterChips" :key="chip.id"
                                    close small
                                    v-on:click:close="removeTag(chip)"
                                    close-icon="mdi-close" color="primary" class="ma-1 lighten-1">
                                {{chip.title}}
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-expand-transition>
                <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style=" width: 100%;">
                    <v-row v-if="toggleName === 0">
                        <v-col xs-3 cols="12" md="4" class="align-flex-start" v-for="(filters, index) in filterLayout" :key="index">
                            <v-flex class="d-flex mb-5 test" v-for="(filterItem, index) in filters" :key="index">
                                <template v-if="filterItem">
                                    <div class="pt-2 mr-1" style="width: 100px; min-width: 100px; font-size: 14px;">
                                        {{filterItem.title}}
                                    </div>
                                    <v-select
                                        multiple
                                        v-model="filterOptions[filterItem.data]"
                                        :items="metaData[filterItem.data]"
                                        item-text="value"
                                        item-value="id"
                                        :placeholder="'Select '"
                                        dense
                                        solo
                                        lighten-1
                                        class="ml-2"
                                        style="width: 230px; max-width: 230px;"
                                        v-if="!filterItem.autocomplete"
                                        @change="changeSelect()"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item.value : item}}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                            >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                        </template>
                                    </v-select>
                                    <v-autocomplete
                                        v-else
                                        v-model="filterOptions[filterItem.data]"
                                        :items="metaData[filterItem.data]"
                                        item-text="value"
                                        item-value="id"
                                        multiple
                                        dense
                                        solo
                                        lighten-1
                                        :search-input.sync="searchInputAutocomplete[filterItem.typeAutocomplete]"
                                        @change="changeOption(filterItem.typeAutocomplete)"
                                        class="ml-2"
                                        style="width: 230px; max-width: 230px;"
                                        :placeholder="'Select '"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item.value : item}}</span>
                                            <span v-if="index === 1" class="grey--text caption">(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                        </template>
                                        <template v-slot:item="{ item, attrs, on }" v-if="filterItem.data === 'taskTemplates'">
                                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <span class="text-uppercase">{{ item.value }}</span>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </template>
                            </v-flex>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu
                                ref="menuRange"
                                v-model="menuRange"
                                :return-value.sync="dates"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="computedDatesFormatted"
                                        label="Date range"
                                        v-on="on"
                                        v-bind="attrs"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        class="mt-n2"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="dates" range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menuRange = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="saveDates(dates)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row v-if="toggleName === 1">
                        <v-col cols="12" md="4">
                            <v-menu
                                ref="lateMenuRange"
                                v-model="lateMenuRange"
                                :return-value.sync="lateDates"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="computedLateDatesFormatted"
                                        label="Date range"
                                        v-on="on"
                                        v-bind="attrs"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="lateDates" range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="lateMenuRange = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="saveLateDates(lateDates)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card>
            </v-expand-transition>
            <v-row class="d-block lighten-4 d-flex justify-space-between align-center">
                <v-col v-if="showData">
                    <v-progress-linear indeterminate color="green" v-if="isLoadingPages"></v-progress-linear>
                    <v-data-table
                        v-if="toggleName === 0"
                        :headers="headers"
                        :items="holidays"
                        :items-per-page="options.itemsPerPage"
                        :server-items-length="totalItems"
                        :options.sync="options"
                        no-data-text="No holidays"
                        class="elevation-0 d-block employees-table"
                        @update:options="loadEmployees"
                        :footer-props="{'items-per-page-options': [5,10,15,20]}"
                        @click:row="leaveRowClick"
                    >
                        <template v-slot:item.startDate="{ item }">
                            <div class="d-flex align-center">
                                <v-icon class="mr-3">${{convertTypeOfHoliday(item.type)}}</v-icon>
                                {{Date.formatDate([item.startDate])}}
                            </div>
                        </template>
                        <template v-slot:item.createdOn="{ item }">
                            {{Date.formatDate([item.createdOn])}}
                        </template>
                        <template v-slot:item.duration="{ item }">
                            {{item.duration}}
                        </template>
                        <template v-slot:item.workingDuration="{ item }">
                            {{item.workingDuration}}
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{statusByDictionary(item.status, item.type)}}
                        </template>
                        <template v-slot:item.statusSetBy="{ item }">
                            {{statusSetBy(item.statusSetBy, item.type)}}
                        </template>
                        <template v-slot:item.type="{ item }">
                            {{item.type}}
                        </template>
                    </v-data-table>
                    <v-data-table
                        v-if="toggleName === 1"
                        :headers="lateHeaders"
                        :items="lateList"
                        :items-per-page="lateOptions.itemsPerPage"
                        :server-items-length="totalLateItems"
                        :options.sync="lateOptions"
                        no-data-text="No lates"
                        class="elevation-0 d-block"
                        @update:options="getLateList"
                        :footer-props="{'items-per-page-options': [5,10,15,20]}"
                        @click:row="lateRowClick"
                    >
                        <template v-slot:item.date="{ item }">
                            <div class="d-flex align-center">
                                <v-icon class="mr-3">${{convertTypeOfHoliday('Late')}}</v-icon>
                                {{Date.formatDate([item.date])}}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-row>
        <type-holiday-popup
            :isOpen="showPopup"
            :holidayItems="holidayTypes"
            @closeModal="closePopup"
            @selectedType="selectedType"
        ></type-holiday-popup>
    </v-container>
</template>
<script>
import MainAppBar from '@/components/MainAppBar'
import TypeHolidayPopup from './components/TypeHolidayPopup'
import selectInputAutocomplete from '@/constatns/selectInputAutocomplete'
import { mapActions, mapGetters } from 'vuex'
import { TYPES_HOLIDAY, arrayStatusesHoliday, arrayTypesHoliday } from '@/constatns/typesOfHolidays'

const defaultFilterOptions = {
    leaveRequestStatuses: [],
    leaveRequestTypes: []
}

export default {
    data () {
        return {
            showData: false,
            employeeIds: null,
            toggleName: 0,
            dates: [],
            menuRange: false,
            lateDates: [],
            lateMenuRange: false,
            lateList: [],
            totalLateItems: 0,
            showPopup: false,
            isAdminAccess: null,
            title: null,
            isAdmin: false,
            holidays: [],
            filterOpened: false,
            metaData: {},
            isLoadingPages: false,
            totalItems: 1,
            filterOptions: {},
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['StartDate'],
                sortDesc: [true],
                mustSort: false,
                multiSort: false
            },
            lateOptions: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['date'],
                sortDesc: [true],
                mustSort: false,
                multiSort: false
            },
            searchInputAutocomplete: {
                [selectInputAutocomplete.statuses]: null,
                [selectInputAutocomplete.types]: null
            },
            holidayTypes: [],
            filteringTimerId: null
        }
    },
    computed: {
        ...mapGetters({
            getFilterDateCurrentYearNextYear: 'getFilterDateCurrentYearNextYear',
            getAllUserPermissions: 'getAllUserPermissions',
            getTypesHoliday: 'getTypesHoliday'
        }),
        headers () {
            const headers = [
                {
                    text: 'Start date',
                    align: 'left',
                    sortable: true,
                    value: 'startDate'
                },
                {
                    text: 'Created',
                    align: 'left',
                    sortable: true,
                    value: 'createdOn'
                },
                {
                    text: 'Duration',
                    align: 'center',
                    sortable: true,
                    value: 'duration'
                },
                {
                    text: 'Working Duration',
                    align: 'center',
                    sortable: true,
                    value: 'workingDuration'
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Status set by',
                    align: 'center',
                    sortable: true,
                    value: 'statusSetBy'
                },
                {
                    text: 'Type',
                    align: 'center',
                    sortable: true,
                    value: 'type'
                }
            ]
            return headers
        },
        lateHeaders () {
            const headers = [
                {
                    text: 'Date',
                    align: 'left',
                    sortable: true,
                    value: 'date'
                }
            ]
            return headers
        },
        filterLayout () {
            const filterLayout = [
                [
                    {
                        title: 'Statuses:',
                        data: 'leaveRequestStatuses',
                        model: 'leaveRequestStatuses',
                        type: 'arr',
                        autocomplete: false,
                        typeAutocomplete: selectInputAutocomplete.statuses
                    },
                    {
                        title: 'Type:',
                        data: 'leaveRequestTypes',
                        model: 'leaveRequestTypes',
                        type: 'arr',
                        autocomplete: false,
                        typeAutocomplete: selectInputAutocomplete.types
                    }
                ]
            ]
            return filterLayout
        },
        filterChips () {
            const filterTags = []
            for (const key in this.filterOptions) {
                const optionValue = this.filterOptions[key]
                if (Array.isArray(optionValue)) {
                    optionValue.forEach(opt => {
                        const tag = {
                            id: this.$uuid.v1(),
                            key
                        }
                        if (isFilterItemObj(key)) {
                            const tagInfo = this.metaData[key] ? this.metaData[key].find(metaItem => metaItem.id === opt) : {}
                            tag.title = key === 'taskTemplates' ? tagInfo.value.toUpperCase() : tagInfo.value
                            tag.value = tagInfo.id
                        } else {
                            tag.title = opt
                            tag.value = opt
                        }
                        filterTags.push(tag)
                    })
                } else {
                    const tag = {
                        id: this.$uuid.v1(),
                        key
                    }
                    if (optionValue.value) {
                        tag.title = optionValue.getTitle()
                        tag.value = optionValue.value
                        filterTags.push(tag)
                    }
                }
            }
            return filterTags

            function isFilterItemObj (key) {
                return ['categories', 'taskTemplates'].indexOf(key) !== -1
            }
        },
        computedDatesFormatted () {
            const localDates = this.dates.map((item) => {
                return Date.getFormatDateStr(item)
            })
            return localDates.join(' ~ ')
        },
        computedLateDatesFormatted () {
            const localDates = this.lateDates.map((item) => {
                return Date.getFormatDateStr(item)
            })
            return localDates.join(' ~ ')
        },
        routeName () {
            return this.$router.currentRoute.name
        }
    },
    async mounted () {
        this.resetFilters()
        this.employeeIds = this.$route.params.id
        this.isAdminAccess = this.$route.meta.adminAccess

        const employeeInfo = await this.fetchEmployeeInfo(this.employeeIds)

        this.employeeIds = employeeInfo.id
        this.title = employeeInfo.firstName + ' ' + employeeInfo.lastName

        const responseTypesOfHoliday = await this.fetchTypesOfHolidays({
            employeeId: this.employeeIds
        })
        const { filteredTypesHoliday, supervisorHolidays } = responseTypesOfHoliday

        this.holidayTypes = filteredTypesHoliday

        const filteredTypes = this.holidayTypes
            .filter(item => {
                if (item.isFirstLevel === true && item.isSecondLevel === true) {
                    return this.hasApproveLevels(supervisorHolidays) || supervisorHolidays.isSuperApprover ? { ...item } : null
                }
                return { ...item }
            })
            .filter(item => {
                if (item.isSickPermissionInDefaultClinic) {
                    return supervisorHolidays.isSickPermissionInDefaultClinic || supervisorHolidays.isSuperApprover ? { ...item } : null
                }
                return { ...item }
            })
            .filter(item => {
                if (item.isMaternityLeaveInDefaultGroup) {
                    return supervisorHolidays.isMaternityLeaveInDefaultGroup || supervisorHolidays.isSuperApprover ? { ...item } : null
                }
                return { ...item }
            })
        this.holidayTypes = filteredTypes
        this.showData = true
    },
    methods: {
        ...mapActions([
            'setFilteredDate',
            'fetchHolidaysOfUser',
            'fetchTypesOfHolidays',
            'fetchEmployeeInfo',
            'showAlert',
            'getLates'
        ]),
        leaveRowClick (item) {
            this.$router.push({ name: 'editEmployeeHoliday', params: { id: item.id } })
        },
        lateRowClick (item) {
            this.$router.push({ name: 'editEmployeeLate', params: { id: item.id } })
        },
        async loadEmployees () {
            this.isLoadingPages = true
            const params = {
                ...this.filterOptions,
                employeeIds: this.employeeIds,
                from: this.dates[0],
                to: this.dates[1],
                pageSize: this.options.itemsPerPage,
                pageNumber: this.options.page,
                sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC',
                sortField: this.options.sortBy[0] || 'id'
            }
            try {
                const response = await this.fetchHolidaysOfUser({
                    params: params
                })
                const data = response.data
                this.metaData = data.metadata
                this.metaData = {
                    ...this.metaData,
                    leaveRequestStatuses: this.metaData.leaveRequestStatuses.map(item => {
                        const findedValue = arrayStatusesHoliday.find((status) => item.id === status.value ? status : null)
                        if (!findedValue) return
                        return {
                            ...item,
                            value: findedValue.publicTitle
                        }
                    }).filter(item => item)
                }
                this.totalItems = data.metadata.totalElements
                if (data.items.length) {
                    this.holidays = []
                    this.holidays = data.items
                }
                this.isLoadingPages = false
            } catch (e) {
                console.log(e.message)
                this.holidays = []
                this.isLoadingPages = false
                this.loadingTaskTemplates = false
            }
        },
        statusByDictionary (status, type) {
            const rightStatus = arrayStatusesHoliday.find(item => item.name === status).publicTitle
            const findedType = arrayTypesHoliday.find(item => item.title === type)
            return findedType.isVisibleType ? rightStatus : null
        },
        statusSetBy (value, holidayType) {
            if (value && (holidayType === TYPES_HOLIDAY.HOLIDAY_NAME || holidayType === TYPES_HOLIDAY.COLLEGE_DAY_NAME || holidayType === TYPES_HOLIDAY.MATERNITY_APPOINTMENT_NAME || holidayType === TYPES_HOLIDAY.OTHER_APPOINTMENT_NAME)) {
                return value
            } else return ''
        },
        changeSelect () {
            this.options.page = 1
            this.loadEmployees()
        },
        changeOption (typeSearch) {
            this.searchInputAutocomplete[typeSearch] = ''
            this.options.page = 1
            this.loadEmployees()
        },
        closePopup () {
            this.showPopup = false
        },
        selectedType (value) {
            if (value.employeeHasOpenSickLeave) {
                this.showAlert({
                    text: 'Ongoing Sick Leave already exists. Previous one should be Locked in order to start a new one',
                    type: 'error'
                })
                return
            }
            if (value.selectedType === TYPES_HOLIDAY.LATE) {
                this.$router.push({ name: 'createEmployeeLate' })
            } else {
                this.$router.push({ name: 'createEmployeeHoliday', query: { type: value } })
            }
        },
        removeTag (chip) {
            if (chip.key) {
                const filterOption = this.filterOptions[chip.key]
                if (Array.isArray(filterOption)) {
                    this.filterOptions[chip.key] = filterOption.filter(option => chip.value !== option)
                } else {
                    this.filterOptions[chip.key] = defaultFilterOptions[chip.key]
                }
            }
            this.isLoadingPages = false
            this.loadEmployees()
        },
        hasApproveLevels ({ isFirstLevel, isSecondLevel }) {
            if (isFirstLevel === true && isSecondLevel === true) return true
            if (isFirstLevel === true && isSecondLevel === false) return true
            if ((isFirstLevel === false || isFirstLevel === undefined) && isSecondLevel === true) return true
            if ((isFirstLevel === false || isFirstLevel === undefined) && isSecondLevel === false) return false
        },
        goBack () {
            this.$router.go(-1)
        },
        convertTypeOfHoliday (typeOfHoliday) {
            return typeOfHoliday.toLowerCase().split(' ').join('')
        },
        saveDates (dates) {
            this.$refs.menuRange.save(dates.sort())
            this.options.page = 1
            this.loadEmployees()
        },
        saveLateDates (dates) {
            this.$refs.lateMenuRange.save(dates.sort())
            this.lateOptions.page = 1
            this.getLateList()
        },
        resetFilters () {
            this.filterOptions = { ...defaultFilterOptions }
            this.dates = [`${new Date().getFullYear() - 1}-01-01`, `${new Date().getFullYear() + 1}-12-31`]
            this.lateDates = [`${new Date().getFullYear() - 1}-01-01`, `${new Date().getFullYear() + 1}-12-31`]
        },
        async getLateList () {
            const queryData = {
                EmployeeIds: this.employeeIds,
                from: this.lateDates[0],
                to: this.lateDates[1],
                pageSize: this.lateOptions.itemsPerPage,
                pageNumber: this.lateOptions.page,
                sortOrder: this.lateOptions.sortDesc[0] === true ? 'DESC' : this.lateOptions.sortDesc[0] === false ? 'ASC' : null,
                sortField: this.lateOptions.sortBy[0] || null
            }
            try {
                this.isLoadingPages = true
                const lateResponse = await this.getLates(queryData)
                this.lateList = lateResponse.data.items
                this.totalLateItems = lateResponse.data.metadata.totalElements
                this.isLoadingPages = false
            } catch (e) {
                this.isLoadingPages = false
            }
        }
    },
    components: {
        MainAppBar,
        TypeHolidayPopup
    }
}
</script>
<style scoped lang="scss">
    .holidays-card {
        .v-list-item {
            min-height: auto;
            font-size: 14px;
            display: block;
            &__content {
                padding: 2px 0;
            }
        }
    }
    .v-skeleton-task-template {
        display: block;
        overflow: visible;
        opacity: 1;
        visibility: visible;
        width: 100%;
    }

    .employees-table {
        tr {
            cursor: pointer;
        }
    }

    .btn-filter {
        svg {
            fill: #000
        }
    }

    .btn-back {
        position: absolute;
        top: 50%;
        left: 43px;
        transform: translateY(-50%);

        @media (min-width: 1264px){
            left: 13px;
        }
    }
</style>
